<template>
  <div class="box-big">
    <el-row style="width:80%;margin: 0 auto;" class="box-b">
      <el-col :span="4">
        <p>文件列表</p>
        <ul class="ull">
          <li v-for='(m, index) in fileLists' :key="index" @click="fileclick(m,index)" :class='{activess:activeli === index}' :title="formatPlanDoc(m.type)">
            <span slot="label">
              <i class="text_red" v-if="m.required">*</i>
              <i class="iconfont icon-wenjian-copy1" :class="{'activess2':plandocState[m.type]}"></i>
              {{formatPlanDoc(m.type)}}</span>
          </li>
        </ul>
        <div style="margin:10px 0px 0px 15px;">
          <el-button type="text" @click="downloadTemplate" >下载备案表模板</el-button>
        </div>
        <div style="margin-left:15px;">
          <el-button type="text" style="position:relative">
            查看示例
            <viewer :images="photo" class="seeBigImg">
            <img
              v-for="(src,index) in photo"
              :src="src"
              :key="index"
            >
          </viewer>
          </el-button>

        </div>
      </el-col>
      <el-col :span="20">
        <pdf v-if="show" ref="pdf" :src="fileaddress" :activeData="activeData" @changeFile="changeFile" @showPercent="showPercent" :isLoading="isLoading" @onError="onError" @onChange="onChange" @downloadTemplate="downloadTemplate"></pdf>
      </el-col>
    </el-row>
    <el-dialog title='文件上传中' :visible.sync="dialogVisible" size="tiny" style="text-align:center">
      <img src="./../../../static/img/2.gif" height="64" width="64">
      已上传{{percent}}%
      <span slot="footer" class="dialog-footer">
        <el-button @click="abortUpload();dialogVisible = false">终止上传</el-button>
      </span>
    </el-dialog>
    <el-dialog title="示例" :visible.sync="imgshow" size="tiny">
      <img width="100%" :src="imageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import { upload } from './../../data/ajax'
import fillingInfo from './../../data/basic/weather/filling'
// import pdf from './../general/pdf.vue'
import pdf from './../general/pdfNew.vue'
import Apis from '../../data/api';
export default {
  props: {
    num: {
       type: Number,
       default: 2,
    },
    fileLists:{
      type: Array,
      required: false,
      default: () => [{
          type: 51,
          value: '备案表',
          id: '',
          required: true
        }, {
          type: 52,
          value: '预案',
          id: '',
          required: true
        }, {
          type: 53,
          value: '专家评审意见',
          id: '',
          required: false
        }
      ]
    },
    subjectId:{
       type: String,
       default: '0',
    },
    planType:{
       type: String,
       default: 'heavyweather',
    }
  },
  components: {
    pdf
  },
  data() {
    return {
        isValidateForm: true,
      imgshow: false,
      isLoading:false,
      imageUrl: '',
      show: true,
      loadedRatio: 0,
      page: 1,
      numPages: 0,
      rotate: 0,
      plandocdata: null,
      // 文件上传状态
      plandocState: {},
      // 选中的数据
      activeData: {
        type: 51,
        value: '',
        id: ''
      },
      dialogVisible: false,
      fileName: '重污染天气应急响应操作方案备案表',
      activeli: 0,
      iscolor: [],
      fileaddress: '',
      datalist: {
        planId: null,
        type: 51,
        typeDes: '' // 描述
      },

      photo:[],
      percent:'0',
    }
  },
  watch: {
    fileLists() {
      if (this.plandocdata.length < 1) {
        return
      } else {
        if(this.activeli < this.plandocdata.length){
          this.activeData.id = this.plandocdata[this.activeli].id
        }else{
          this.activeData.id = ''
        }
      }
    },
    plandocdata() {
      this.format_plandocdata(this.plandocdata)
    }
  },
  created() {
      Apis.getEnv().then((resp) => {
          this.isValidateForm = resp.isValidate;
          if (typeof resp.isValidate === "string") {
              this.isValidateForm = resp.isValidate === "true" ? true : false;
          }
      });
    this.plandoclist()
    setTimeout(() => {
      if(this.fileLists[0] && this.fileLists[0].id){
          this.fileaddress = `/api/emer/plandoc/download?id=${this.fileLists[0].id}&isOnline=true`
      }
    }, 500)
    this.datalist.planId = sessionStorage.planIdval
    let ImageUrl = `/api/emer/plan/${this.planType}/example?subjectId=${this.subjectId}`
    this.photo.push(ImageUrl)
  },
  methods: {
    downloadTemplate(){
        window.location.href = `/api/emer/plan/${this.planType}/template?subjectId=${this.subjectId}`
    },
    showExample(){
      this.imageUrl = `/api/emer/plan/${this.planType}/example?subjectId=${this.subjectId}`
      this.imgshow = true
    },
    //终止文件上传
    abortUpload() {
      this.$refs.pdf.abort();
    },
    // 改变
    onChange() {
      this.dialogVisible = true
    },
    // 成功
    changeFile(fileList) {
      this.plandoclist()
      setTimeout(() => {
        this.dialogVisible = false
      }, 1000)
      let fileID = fileList.id
      if(fileID){
        // setTimeout(() => {
        this.dialogVisible = false
        this.fileaddress = `/api/emer/plandoc/download?id=${fileID}&isOnline=true&num=${Math.random()}`
      // }, 1000)
      }
    },

    //监听上传进度
    showPercent(percent){

    },
    // 方法
    format_plandocdata(data) {
      const plandocState = {}
      data.forEach((m) => {
        plandocState[m.type] = true
      })
      this.plandocState = plandocState
    },
    // 获取文件列表
    plandoclist() {
      (async() => {
        let pID = sessionStorage.planIdval
        try {
          let data = await fillingInfo.plandoc_list({
            planId: pID
          })
          this.plandocdata = data.data
          this.dialogVisible = false
          for (let i = 0; i < this.plandocdata.length; i++) {
            for (let j = 0; j < this.fileLists.length; j++) {
              if (this.plandocdata[i].type == this.fileLists[j].type) {
                this.fileLists[j].id = this.plandocdata[i].id
                this.fileLists[j].fileName = this.plandocdata[i].fileName
              }
            }
          }
        } catch (err) {
          this.$message.error('文件列表获取失败,请稍后重试')
        }
      })()
    },
    // 获取Token
    getSession() {
      return sessionStorage.getItem('publicToken')
    },
    // 图片文件的监测
    onChange9(fileList, file) {
      let file_name = /\.[^\.]+/.exec(fileList.name)
      if (file_name == '.png') {
        this.$message.error('不支持图片PNG')
      } else {
        this.dialogVisible = true
      }
    },
    onError(msg) {
      this.dialogVisible = false
      if(msg){
        this.$message.error(msg);
      }else{
        this.$message.error("文件格式转换超时,请本地转成pdf后上传");
      }
      setTimeout(() => {
        this.dialogVisible = false
      }, 1000)
    },
    // 控制按钮/显示类型的
    startUpFile() {
        if(!this.isValidateForm) {
            return false;
        }
      if (this.plandocdata.length < this.num) {
        let existDoc = [];
        this.plandocdata.forEach(element => {
            existDoc.push(element.type);
        });
        for(var i =0;i< this.fileLists.length;i++){
          if(this.fileLists[i].required == true && existDoc.indexOf(this.fileLists[i].type) == -1){
                // this.$message.error('请补充上传所必需的附件')
                this.$message.error('请补充上传所必需的附件')
                this.fileclick(this.fileLists[i],i)
                break
            }
        }

        //this.$message.error('备案文件不完整，请补充上传所需的附件')
        return true
      } else {
        let existDoc = [];
        this.plandocdata.forEach(element => {
            existDoc.push(element.type);
        });
        this.fileLists.forEach(element => {
            if(element.required == true && existDoc.indexOf(element.type) == -1){
                this.$message.error('请补充上传所必需的附件')
                return true
            }
        });
        return false
      }
    },
    formatPlanDoc(num, filename) {
      let docName = ''
      switch (num) {
        case 1:
          docName = '备案表'
          break
        case 2:
          docName = '应急预案'
          break
        case 3:
          docName = '风险评估报告'
          break
        case 4:
          docName = '应急资源调查报告'
          break
        case 5:
          docName = '专家评审意见书'
          break
        case 6:
          docName = '补充其他（平面图等）'
          break
        case 7:
          docName = '审查意见书'
          break
        case 8:
          docName = '编制说明'
          break
        case 51:
          docName = '备案表'
          break
        case 52:
          docName = '应急预案'
          break
        case 53:
          docName = '专家评审意见书'
          break
        case 54:
          docName = '应急响应减排措施及现场核查表'
          break
        case 55:
          docName = '审查意见书'
          break
        case 98:
          docName = '其他 '
          break
        case 99:
          docName = '其他 '
          break
        default:
          docName = "其他 ";
          break;
      }
      return docName
    },
    // 选中不同的文件
    fileclick(val, index) {
      this.activeli = index
      this.fileName = val.value
      this.datalist.type = val.type
      this.activeData = val
      if (val.fileName == '') {
        this.fileaddress = ''
      } else {
        if (val.id) {
          let addres = val.id
          if(addres){
            this.fileaddress = `/api/emer/plandoc/download?id=${addres}&isOnline=true`
          }
        } else {
          this.fileaddress = ''
        }
      }
    },
  }
}

</script>
<style lang="stylus" scoped>
.box-big {
  margin-top: 5px;
  height: 600px;
}

.box-big i {
  font-size: 12px;
}

.upload-demo {
  height: 37px;
  text-align: right;
}

.file-box {
  width: 100%;
  border: #eef1f6 1px solid;
  margin-top: 2px;
}

.file-box-top {
  background-color: #e4e4e4;
  padding: 3px 4px;
  margin-top: 10px;
  color: #000;
  input {
    width: 50px;
    font-size: 14px;
    text-indent: 2px;
  }
  i {
    font-size: 18px;
    cursor: pointer;
    margin: 0 3px;
    &:first-child {}
    &:last-child {}
  }
  span {
    cursor: pointer;
  }
}

.ull {
  li {
    float: left;
    list-style: none;
    height: 40px;
    box-sizing: border-box;
    line-height: 40px;
    padding: 0 10px;
    border: 1px solid transparent;
    cursor: pointer;
    width: 100%;
    color: #666;
    i {
      display: inline-block;
      font-size: 16px;
      color: red;
      float: left;
      margin-right: 3px;
    }
    span {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
    }
  }
}

.activess {
  background-color: #fff;
  box-sizing: border-box;
  border-bottom-color: #fff!important;
  border-radius: 4px 4px 0 0;
  position: relative;
  span {
    color: #20a0ff;
  }
}

.text_red{
  color: red
}

.activess2 {
  color: rgb(26, 250, 41)!important;
}

.coloractive1 {
  color: #1afa29
}

.file-box-bottom {
  min-height: 630px;
  clear: both;
}

.box-big {
  margin-bottom: 20px;
}

.annotationLayer {
  position: relative;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.box {
  box-sizing: border-box;
  height: 1000px;
  margin: 0 auto;
  overflow: hidden;
}

.box-pdf {
  border: solid 1px #d1dbe5;
  height: 600px;
}

.box-t-l {
  box-sizing: border-box;
  ul li {
    cursor: pointer;
    box-sizing: border-box;
    border: 1px solid transparent;
    text-align: left;
    padding: 10px;
    span {
      font-size: 14px;
    }
  }
}

.box-t-rb {
  padding-left: 10px;
  p {
    padding-left: 10px;
    line-height: 35px;
    span {
      font-size: 14px;
    }
  }
}

.errTips {
  color: red;
}

.a-hover {
  color: #409eff;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.head-title {
  border-bottom: none!important
}

.ep-pdf {
  height: 600px;
}

.box-b {
  border: solid 1px #E1E5F2;
  height: 100%;
  overflow: hidden;
  p {
    line-height: 44px;
    font-size: 16px;
    padding-left: 20px;
    border-bottom: 1px solid #E1E5F2;
  }
  .el-col-4 {
    border-right: solid 1px #E1E5F2;
    height: 100%;
  }
}

.seeBigImg {
  position :absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  opacity :0;
  img {
    width:100%;
    height:100%;
  }
}

</style>



// WEBPACK FOOTER //
// FileUpload.vue?1e398357